<template>
    <BtnVoltar></BtnVoltar>
    <div class="mb-4">
        <h5 class="mb-0 lato-bolder" style="margin-bottom: 0.5rem !important; color: #282a31">Visão Detalhada</h5>
        <div class="p-fluid flex flex-row align-items-center justify-content-between">
            <div class="flex flex-row align-items-center justify-content-center">
                <Tag class="bg-cinza lato-bolder text-black-alpha-90 mr-1" rounded>nº {{ bordero?.idbordero }}</Tag>
                <Tag class="bg-cinza lato-bolder text-black-alpha-90" rounded>{{ bordero?.statusDescricao }}</Tag>
            </div>

            <p class="lato-medium" style="color: #666666">{{ bordero?.lancamentos.length }} lançamentos</p>
        </div>
    </div>

    <div class="p-fluid formgrid grid">
        <div class="field col-12 md:col-6">
            <DetalheBorderoCard :bordero="bordero"></DetalheBorderoCard>
        </div>
        <div class="field col-12 md:col-6">
            <AcaoCardDetalhe :acoes="bordero?.acoes"></AcaoCardDetalhe>
        </div>
        <div class="field col-12">
            <LancamentosListagem @visualizouLancamento="obterBordero()" :lancamentos="bordero?.lancamentos"></LancamentosListagem>
        </div>
    </div>

    <div class="fixed bottom-0 left-0 p-2 botao-flutuante bg-white" v-if="$temAcessoView('BORDEROS-05') && bordero?.usuarioAtualPodeAprovar">
        <div
            class="flex flex-row align-items-center justify-content-center"
            v-if="
                (!ehGerenteFinanceiro && bordero?.usuarioAtualPodeAprovar) ||
                (ehGerenteFinanceiro && bordero?.usuarioAtualTipoAprovacao === 0 && bordero?.status !== 2 && bordero?.status !== 3)
            "
        >
            <Button
                class="lato-bolder bg-btn-reprovar margin-personalizada-btns btn-comum w-full flex flex-row align-items-center justify-content-center"
                @click="confirmarAprovarReprovar('reprovar')"
                style="font-family: 'Lato', Arial, sans-serif; font-weight: 700; font-size: 16px; color: #e0e3e7"
            >
                Reprovar
                <i class="pi pi-times mt-1 ml-2"> </i>
            </Button>

            <Button
                class="lato-bolder bg-btn-aprovar btn-comum w-full flex flex-row align-items-center justify-content-center gap-1"
                @click="confirmarAprovarReprovar('aprovar')"
                style="font-family: 'Lato', Arial, sans-serif; font-weight: 700; font-size: 16px; color: #fff"
            >
                {{ !ehGerenteFinanceiro ? 'Aprovar' : 'Visto' }}
                <i class="pi pi-check mt-1 ml-2"> </i>
            </Button>
        </div>

        <div
            class="flex flex-row align-items-center justify-content-center"
            v-if="
                ehGerenteFinanceiro &&
                bordero?.usuarioAtualTipoAprovacao === 1 &&
                bordero?.usuarioAtualPodeAprovar &&
                bordero?.status !== 2 &&
                bordero?.status !== 3
            "
        >
            <Button
                class="lato-bolder bg-btn-aprovar btn-comum w-full flex flex-row align-items-center justify-content-center gap-1"
                @click="confirmarAprovarReprovar('aprovar')"
                style="font-family: 'Lato', Arial, sans-serif; font-weight: 700; font-size: 16px; color: #fff"
            >
                Transmissão
                <i class="pi pi-check mt-1 ml-2"> </i>
            </Button>
        </div>
    </div>
</template>

<script>
import DetalheBorderoCard from './DetalheBorderoCard.vue';
import AcaoCardDetalhe from './acoes/AcaoCardDetalhe.vue';
import LancamentosListagem from './lancamentos/Listagem.vue';
import BtnVoltar from './BtnVoltar.vue';
import BorderoService from './service';

export default {
    components: {
        AcaoCardDetalhe,
        DetalheBorderoCard,
        LancamentosListagem,
        BtnVoltar,
    },

    data() {
        return {
            bordero: null,
        };
    },

    methods: {
        obterBordero() {
            this.$store.dispatch('addRequest');
            BorderoService.obterPorId(this.$route.params?.borderoId)
                .then((response) => {
                    if (response?.data) {
                        this.bordero = response.data;
                    }
                })
                .finally(() => this.$store.dispatch('removeRequest'));
        },

        confirmarAprovarReprovar(acao = 'aprovar') {
            this.$confirm.require({
                message: `Tem certeza que deseja ${acao.toLowerCase()} o borderô ${this.bordero?.idbordero}?`,
                header: 'Confirmação',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    if (acao == 'aprovar') {
                        this.aprovar();
                    } else {
                        this.reprovar();
                    }
                },
            });
        },

        aprovar() {
            this.$store.dispatch('addRequest');
            const aprovarBordero = { borderos: [this.bordero?.borderoId] };
            BorderoService.aprovarBordero(aprovarBordero).then((response) => {
                if (response?.success) {
                    this.obterBordero();
                    this.$toast.add({ severity: 'success', summary: 'Sucesso!', detail: 'Borderô aprovado com sucesso', life: 3000 });
                } else {
                    this.$toast.add({ severity: 'error', summary: 'Error!', detail: 'Erro ao aprovar borderô', life: 3000 });
                    this.erros = response.errors;
                }
                this.$store.dispatch('removeRequest');
            });
        },

        reprovar() {
            this.$store.dispatch('addRequest');
            const borderoReprovadoDto = { borderos: [this.bordero?.borderoId] };
            BorderoService.reprovarBordero(borderoReprovadoDto).then((response) => {
                if (response?.success) {
                    this.obterBordero();
                    this.$toast.add({ severity: 'success', summary: 'Sucesso!', detail: 'Borderô reprovado com sucesso', life: 3000 });
                } else {
                    this.$toast.add({ severity: 'error', summary: 'Error!', detail: 'Erro ao reprovar borderô', life: 3000 });
                    this.erros = response.errors;
                }
                this.$store.dispatch('removeRequest');
            });
        },
    },

    mounted() {
        this.obterBordero();
    },

    computed: {
        ehGerenteFinanceiro() {
            return this.$temAcessoView('BORDEROS-06') && this.$temAcessoView('BORDEROS-07') && this.$temAcessoView('BORDEROS-08');
        },
    },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap');

.lato-bolder {
    font-family: 'Lato', Arial, sans-serif;
    font-weight: 700;
}

.lato-medium {
    font-family: 'Lato', Arial, sans-serif;
    font-weight: 500;
}

.bg-cinza {
    background-color: #ebebeb;
}

@media (min-width: 1024px) {
    .col-19w {
        width: 19%;
    }
}

.tamanho-com-menu {
    width: calc(100% - 288px);
    left: 288px;
}

.m-left {
    margin-left: 288px;
}

.bg-btn-aprovar {
    border-color: #3e6ba8;
    background-color: #3e6ba8;
}

.bg-btn-aprovar:hover {
    border-color: #3e6ba8;
    background-color: #3e6ba8;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.bg-btn-reprovar {
    border-color: #e54d2e;
    background-color: #e54d2e;
}

.bg-btn-reprovar:hover {
    border-color: #e54d2e;
    background-color: #e54d2e;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.btn-comum {
    height: 2.5rem;
}

.margin-personalizada-btns {
    margin-right: 1.125rem;
}

.botao-flutuante {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
}

@media (min-width: 897px) {
    .botao-flutuante {
        position: fixed;
        bottom: 0;
        left: 288px !important;
        width: calc(100% - 288px);
    }
}
</style>
